export const navigateWithHref = (url: string, partnersKey?: string) => {
  if (!partnersKey) {
    window.location.href = url
  } else {
    window.location.href = `/partners/${partnersKey}${url}`
  }
}

export const getUsimsaInternalUrl = (url: string) => {
  const parsedUrl = new URL(url)
  const isUsimsaDomain =
    parsedUrl.hostname === 'usimsa.com' || parsedUrl.hostname.endsWith('.usimsa.com')

  return isUsimsaDomain ? parsedUrl.href : null
}
